import { IVideoDetail } from "../../../../models/Video.interface";
// import image1 from "./image/1.png";
import image2 from "./image/2.jpg";
// import image3 from "./image/3.png";
// import image4 from "./image/4.png";
// import image5 from "./image/5.png";
// import image6 from "./image/6.png";
import image7 from "./image/7.jpg";
import image8 from "./image/8.jpg";
import image9 from "./image/9.jpg";
import image10 from "./image/10.jpg";
import image11 from "./image/11.jpg";
// import image12 from "./image/12.png";
// import image13 from "./image/13.png";
// import image14 from "./image/14.png";
import image15 from "./image/15.jpg";
import image16 from "./image/16.jpg";
import image17 from "./image/17.png";
import image18 from "./image/18.png";

import image1 from "./2025/1.png";
import image3 from "./2025/3.png";
import image4 from "./2025/4.png";
import image5 from "./2025/5.png";
import image6 from "./2025/6.png";
import image12 from "./2025/12.png";
import image13 from "./2025/13.png";
import image14 from "./2025/14.png";




const VideoTextList2025: Array<IVideoDetail> = [
    {
        url: "https://wehago.com/westudio/#/embed/36xZFf?mode=timeline",
        image_url: image1,
        video_list_no: 99999,
        video_name: "1. 2025년 귀속 연말정산 개정세법",
        contents: "2025년 귀속 연말정산 개정세법",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/SFWwYM?mode=timeline",
        image_url: image2,
        video_list_no: 99999,
        video_name: "2. 연말정산 프로세스",
        contents: "연말정산 프로세스",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/iiDCno?mode=timeline",
        image_url: image3,
        video_list_no: 99999,
        video_name: "3. 사원등록",
        contents: "사원등록",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/BRriyB?mode=timeline",
        image_url: image4,
        video_list_no: 99999,
        video_name: "4. 급여자료입력",
        contents: "급여자료입력",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/iuR9RB?mode=timeline",
        image_url: image5,
        video_list_no: 99999,
        video_name: "5. 국세청 연말정산 간소화입력",
        contents: "국세청 연말정산 간소화입력",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/Czyxlc?mode=timeline",
        image_url: image6,
        video_list_no: 99999,
        video_name: "6. 2025년 귀속 연말정산근로소득원천징수영수증",
        contents: "2025년 귀속 연말정산근로소득원천징수영수증",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/zWzIbu?mode=timeline",
        image_url: image7,
        video_list_no: 99999,
        video_name: "7. 직원신용카드경비사용명세서",
        contents: "직원신용카드경비사용명세서",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/VzRFke?mode=timeline",
        image_url: image8,
        video_list_no: 99999,
        video_name: "8. 사업소득 지급명세서",
        contents: "사업소득 지급명세서",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/cWrYg7?mode=timeline",
        image_url: image9,
        video_list_no: 99999,
        video_name: "9. 퇴직소득 지급명세서",
        contents: "퇴직소득 지급명세서",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/Rv6ANZ?mode=timeline",
        image_url: image10,
        video_list_no: 99999,
        video_name: "10. 기타/이자배당 지급명세서",
        contents: "기타/이자배당 지급명세서",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/H26ntE?mode=timeline",
        image_url: image11,
        video_list_no: 99999,
        video_name: "11. 연말정산 원천징수이행상황신고서",
        contents: "연말정산 원천징수이행상황신고서",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/0nPzAp?mode=timeline",
        image_url: image12,
        video_list_no: 99999,
        video_name: "12. T edge & 나하고 초대/가입 방법",
        contents: "T edge & 나하고 초대/가입 방법",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/jhNPgT?mode=timeline",
        image_url: image13,
        video_list_no: 99999,
        video_name: "13. 나하고 연말정산 미리 해보기",
        contents: "나하고 연말정산 미리 해보기",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/IIalLm?mode=timeline",
        image_url: image14,
        video_list_no: 99999,
        video_name: "14. 나하고 AI 연말정산",
        contents: "나하고 AI 연말정산",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/pLZtPJ?mode=timeline",
        image_url: image15,
        video_list_no: 99999,
        video_name: "15. NAHAGO 연말정산 - 인사담당자용",
        contents: "NAHAGO 연말정산 - 인사담당자용",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/Z6LPfN?mode=timeline",
        image_url: image16,
        video_list_no: 99999,
        video_name: "16. NAHAGO 연말정산 - 직원용",
        contents: "NAHAGO 연말정산 - 직원용",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/rz1pUb?mode=timeline",
        image_url: image17,
        video_list_no: 99999,
        video_name: "17. NAHAGO AI 연말정산 - 인사담당자",
        contents: "NAHAGO AI 연말정산 - 인사담당자",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
    {
        url: "https://wehago.com/westudio/#/embed/smxWps?mode=timeline",
        image_url: image18,
        video_list_no: 99999,
        video_name: "18. NAHAGO AI 연말정산 - 근로자",
        contents: "NAHAGO AI 연말정산 - 근로자",
        view_count: 0,
        runtime: 0,
        created_at: "2025.01.01 01:01",
        updated_at: "2025.01.01 01:01",
        category: { id: 99999, name: "연말정산" },
        video_play_space: [],
    },
];

export default VideoTextList2025;